export interface SourceDataStakeholder {
  name?: string | null;
  role?: string | null;
  organization?: string | null;
  sentiment?: string | null;
  influence?: number | null;
}

export interface Parameter {
  parameter_id?: string | null;
  parameter_label?: string | null;
  value?: number | null;
  bucket_id?: string | null;
  bucket_label?: string | null;
  color?: string | null;
  source_data?: any | null;
  stakeholders?: SourceDataStakeholder[] | null;
}

export interface ContextItem {
  id?: string | null;
  text?: string | null;
  description?: string | null;
  neighborhood_code?: string | null;
  neighborhood_name?: string | null;
  municipality_code?: string | null;
  municipality_name?: string | null;
  district_code?: string | null;
  district_name?: string | null;
  parameters?: Parameter[] | null;
  geometry?: {
    type?: string | null;
    coordinates?: number[][][] | null;
  } | null;
  color?: string | null;
  documents?: Array<{
    url?: string | null;
    date?: string | null;
    title?: string | null;
    source?: string | null;
  }> | null;
}

export interface ContextSubtype {
  context_subtype?: string | null;
  context_subtype_summary?: string | null;
  context_items?: ContextItem[] | null;
}

export interface Context {
  context_type?: string | null;
  summary?: string | null;
  context_items?: ContextItem[] | null;
  context_subtypes?: ContextSubtype[] | null;
}

export interface ContextAnalysisResponse {
  contexts?: Context[] | null;
}

type CoordinateArray = [number, number];
type CoordinateObject = { lon: number; lat: number };

export function contextMapPolygonStyles(): any {
    return ([
        {
        "id": "gl-draw-polygon-fill",
        "type": "fill",
        "filter": ["all", ["==", "$type", "Polygon"]],
        "paint": { 
            "fill-color": "#86EBB8",
            "fill-opacity": 0.4 
            }
        },
        {
        "id": "gl-draw-polygon-stroke",
        "type": "line",
        "filter": ["all", ["==", "$type", "Polygon"]],
        "paint": {
            "line-color": "#00FFC4",
            "line-width": 3,
            "line-dasharray":[0.5,0.5]
        }
        },
        {
        "id": "gl-draw-line",
        "type": "line",
        "filter": ["all", ["==", "$type", "LineString"]],
        "paint": { 
            "line-color": "#0080ff",
            "line-width": 2 
            }
        },
        {
        "id": "gl-draw-polygon-and-line-vertex",
        "type": "circle",
        "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"]],
        "paint": {
            "circle-radius": 4,
            "circle-color": "#0080ff"
        }
        }
    ]);
}

export function convertContextPolygonCoordinates(data: CoordinateArray[]): CoordinateObject[] {
  return data.map(([lon, lat]) => ({
    lon,
    lat
  }));
}

export function extractAllStakeholders(
  data: ContextAnalysisResponse
): SourceDataStakeholder[] {
  const stakeholders: SourceDataStakeholder[] = [];

  // Safety check: ensure data and data.contexts exist
  if (!data || !data.contexts || !Array.isArray(data.contexts)) {
    return stakeholders;
  }

  function visitContextItem(item: ContextItem) {
    for (const param of item.parameters ?? []) {
      if (Array.isArray(param.stakeholders)) {
        stakeholders.push(...param.stakeholders);
      }
    }
  }

  for (const context of data.contexts) {
    for (const item of context.context_items ?? []) {
      visitContextItem(item);
    }

    for (const subtype of context.context_subtypes ?? []) {
      for (const item of subtype.context_items ?? []) {
        visitContextItem(item);
      }
    }
  }

  return stakeholders;
}
